export enum FilterType {
  FILTER_TEXT = 1,
  FILTER_EMAIL,
}

export type TemplateDTO = {
  text: string;
  feedback_count: number;
};

export enum TemplateDetectionStatus {
  TEMPLATE_DETECTION_STATUS_INITIAL = 1,
  TEMPLATE_DETECTION_STATUS_RUNNING,
  TEMPLATE_DETECTION_STATUS_COMPLETE,
  TEMPLATE_DETECTION_STATUS_FAILED,
}

export enum ReanalyzeStatus {
  REANALYZE_STATUS_RUNNING = 1,
  REANALYZE_STATUS_COMPLETE,
  REANALZYE_STATUS_FAILED,
}

export type FilterItemsTextT = {
  texts?: string[];
};

export type ReanalyzeStatusT = {
  reanalyze_status: ReanalyzeStatus;
};

export type TemplateDetectionT = {
  template_detection_status: TemplateDetectionStatus;
  templates?: TemplateDTO[];
};

export type FilterItemsEmailT = {
  emails?: string[];
  email_domains?: string[];
};

export type FilterItemsTextChangeRequest = {
  added_texts?: string[];
  deleted_texts?: string[];
};

export type FilterItemsEmailChangeRequest = {
  added_emails?: string[];
  deleted_emails?: string[];
  added_email_domains?: string[];
  deleted_email_domains?: string[];
};
